import EditPage from './EditPage';

import './EditPage.scss';

export default EditPage;
